import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getPublicSiteUrl } from '../../config/runtimeConfig';
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  DEFAULT_TITLE,
  SITE_NAME,
} from '../../constants/seo';

export default function PageSeo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  ogImage,
  noindex = false,
  jsonLd,
}) {
  const siteUrl = getPublicSiteUrl();
  const canonical = `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`;
  const fullTitle = title || DEFAULT_TITLE;
  const image = ogImage
    ? (ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`)
    : `${siteUrl}${DEFAULT_OG_IMAGE}`;

  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="application-name" content={SITE_NAME} />
      <link rel="canonical" href={canonical} />
      <link rel="manifest" href="/manifest.json" />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow,max-image-preview:large" />
      )}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={`${SITE_NAME} — videomakers sob demanda`} />
      <meta property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={`${SITE_NAME} — videomakers sob demanda`} />

      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd])
          .filter(Boolean)
          .map((block, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(block)}
            </script>
          ))}
    </Helmet>
  );
}
